export default "__VITE_ASSET__B3m5168___"